
import Auth from "../templates/Auth";

import BlocksLogin from "../components/BlocksLogin";
import "primereact/resources/primereact.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "prismjs/themes/prism-coy.css";
import "../assets/demo/flags/flags.css";
import "../assets/demo/Demos.scss";
import "../assets/layout/layout.scss";
import "../App.scss";
import React from 'react';

//import { configSubdomain, useAuthDispatch, logout, useAuthState } from '../context';


const Login = (props) => {
        console.log("login.js");

        //const dispatch = useAuthDispatch();
        //const userDetails = useAuthState();

        //const { subdomain, userName, idSuscripcion, idEmpresa, idioma } = userDetails;
          
    return (
        <Auth>
            <BlocksLogin />
        </Auth>
    );
};

export default Login;
